<div class="login-otp-wrapper">
	<div class="panel login-panel" [class.hidden-anim]="showOtp">
		<form (ngSubmit)="onLogin(f)" #f="ngForm" class="before-login-form">
			<div class="form-group validated-field mb-4">
				<label for="email">{{"login_register.email" | translate}}</label>
				<input type="email" name="email" id="email" ngModel #emailComponent #email="ngModel" required email class="form-control rounded" placeholder="{{'login_register.email' | translate}}" (blur)="checkEmailValidation()">
				<div class="invalid-tooltip" *ngIf="email.touched && email.invalid">
					{{"g.fill_out_massage" | translate}}
				</div>
					<div class="invalid-tooltip" *ngIf="email.touched && !isValidEmail">
					{{"g.invalid_email_format" | translate}}
				</div>
			</div>
			<div class="form-group validated-field">
				<div class="d-flex justify-content-between">
					<label for="email">{{"g.password" | translate}}</label>
					<a routerLink="/forgot-password"><small>{{'login_register.forgot_password' | translate}}?</small></a>
				</div>
				<input type="password" name="password" ngModel #password="ngModel" required class="form-control rounded" placeholder="{{'g.password' | translate}}" show-password>
				<div class="invalid-tooltip" *ngIf="password.touched && password.invalid">
					{{"g.fill_out_massage" | translate}}
				</div>
			</div>
			<div *ngIf="showCaptcha">
				<app-captcha #captchaComponent [fullSize]="true"></app-captcha>
			</div>
			<div class="submit-area form-group">
				<div class="submit-text">
					<p>{{'login_register.do_not_have_account' | translate}} <a routerLink="/register">{{'login_register.sign_up_now' | translate}}</a></p>
					<p>{{'login_register.need_support' | translate}} <a routerLink="/contact">{{'contact_us.title' | translate}}</a></p>
				</div>
				<button type="submit" class="btn">{{'login_register.login' | translate}}</button>
			</div>
		</form>
	</div>

	<!-- OTP panel (kept in DOM so we can animate) - reuse login form styling -->
	<div class="panel otp-panel" [class.visible]="showOtp">
		<form class="before-login-form" (submit)="$event.preventDefault()">
			<div class="form-group">
				<h4>{{'otp.enter_verification_code' | translate}}</h4>
				<p class="muted" *ngIf="!maxAttemptsReached && !accountBlocked && !otpJustResent">{{'otp.otp_sent' | translate: {email: userEmail} }}</p>
				<p class="muted" *ngIf="!maxAttemptsReached && !accountBlocked && otpJustResent">{{'otp.otp_resent' | translate}}</p>
				<p class="muted text-danger" *ngIf="maxAttemptsReached && !accountBlocked">{{'otp.max_attempts_reached_message' | translate}}</p>
				<p class="muted text-danger" *ngIf="accountBlocked">{{'login_register.login_blocked_try_after_x_minutes' | translate: {counter: blockTimeRemaining} }}</p>
			</div>
			<div class="form-group otp-inputs d-flex justify-content-center" *ngIf="!maxAttemptsReached && !accountBlocked">
				<input #otpInput type="text" maxlength="1" class="otp-box" *ngFor="let _ of [0,1,2,3,4,5]; let i = index"
					[(ngModel)]="otp[i]" name="otp{{i}}" (input)="handleOtpInput($event,i)" (paste)="handleOtpPaste($event,i)" (keydown)="handleOtpKeydown($event,i)" autocomplete="one-time-code">
			</div>

			<!-- Normal state: show resend with countdown inside, and verify button -->
			<div class="submit-area form-group otp-actions d-flex justify-content-between align-items-center" *ngIf="!maxAttemptsReached && !accountBlocked">
				<button type="button" class="btn btn-outline" (click)="resendLoginOtp()" [disabled]="resendDisabled" *ngIf="!maxResendAttemptsReached">
					{{'otp.resend' | translate}}<span *ngIf="resendDisabled && resendTimer"> ({{getFormattedCountdown()}})</span>
				</button>
				<span *ngIf="maxResendAttemptsReached"></span>
				<button type="button" class="btn" (click)="verifyOtp()" [disabled]="!isOtpComplete()">{{'otp.verify' | translate}}</button>
			</div>

			<!-- Max attempts state: show only resend button centered -->
			<div class="submit-area form-group otp-actions-centered" *ngIf="maxAttemptsReached && !accountBlocked">
				<button type="button" class="btn btn-outline" (click)="resendLoginOtp()" [disabled]="resendDisabled">{{'otp.request_new_code' | translate}}</button>
			</div>
		</form>
	</div>
</div>
